export const uk = {
    common: {
        PIN_CODE_LABEL: 'PIN-код',
        USER_NAME_LABEL: "Повне ім'я",
        comment: 'Коментар',
        year: 'Рік',
        configuration: 'Конфігурація',
        cancel: 'Скасувати',
        search: 'Пошук',
        remove: 'Видалити',
        confirmationDialogTitle: 'Ви впевнені, що хочете видалити цей елемент?',
        selectDate: 'Виберіть дату',
        select: 'Виберіть',
        notFound: 'Не знайдено',
        equipmentPickerPlaceholder: 'Об’єкт обладнання...',
        searchPlaceholder: 'Пошук...',
        equipmentTypePickerPlaceholder: 'Тип обладнання...',
        equipmentTypePickerTitle: 'Виберіть тип обладнання',
        emptyTableMessage: 'Немає даних',
        flowPikcerTitle: 'Виберіть потік',
        selectIcon: 'Виберіть іконку',
        locationPickerTitle: 'Виберіть місце',
        locationPlaceholder: 'Місце...',
        noSublocations: 'Немає підлокацій',
        locationsTitle: 'Місця',
        edit: 'Редагувати',
        save: 'Зберегти',
        added: 'Додано',
        updated: 'Оновлено',
        add: 'Додати',
        removed: 'Видалено',
        reload: 'Перезавантаження',
        confirm: 'Підтвердити',
        rollBack: 'Відмінити',
        images: 'Зображення',
        documents: 'Документи',
        download: 'Завантажити',
        saved: 'Збережено',
        date: 'Дата',
        hour: 'Година',
        preview: 'Попередній перегляд',
        data: 'Дані',
        attributes: 'Атрибути',
        checkList: 'Список перевірки',
        name: 'Назва',
        type: 'Тип',
        status: 'Статус',
        designation: 'Маркування',
        symbol: 'Символ',
        serialNumber: 'Серійний номер',
        registryNumber: 'Реєстраційний номер',
        machineNumber: 'Номер машини',
        udtNumber: 'UDT номер',
        manufacturedYear: 'Рік виробництва',
        manufacturer: 'Виробник',
        supplier: 'Постачальник',
        mainSupplier: 'Головний постачальник',
        attribute: 'Атрибут',
        nameRequired: 'Необхідно вказати назву',
        yearGreaterThan: 'Рік повинен бути більшим ніж',
        location: 'Місце розташування',
        fieldRequired: "Це поле є обов'язковим",
        description: 'Опис',
        minimumQuantity: 'Мінімальна кількість',
        optimalQuantity: 'Оптимальна кількість',
        priority: 'Пріоритет',
        formatYYYY: 'Формат YYYY',
        storageQuantity: 'Кількість на складі',
        quantity: 'Кількість',
        quantityGreaterThan: 'Кількість має бути більше',
        machine: 'Машина',
        tool: 'Інструмент',
        order: 'Замовлення',
        required: "Обов'язково",
        dateFormat: 'Формат дати',
        selectDictionary: 'Виберіть словник',
        selectDictionaryValue: 'вибрати значення словника',
        return: 'Повернути',
        parameters: 'Параметри',
        editCategory: 'Редагувати категорію',
        addCategory: 'Додати нову категорію',
        changeColor: 'Змінити колір',
        noColor: 'Без кольору',
        shift: 'Зміна',
        start: 'Початок',
        end: 'Кінець',
        shiftSchema: 'Схема змін',
        shifts: 'Зміни',
        dictionary: 'Словник',
        subEntries: 'Підзаписи',
        key: 'Ключ',
        value: 'Значення',
        moveUp: 'Перемістити вгору',
        moveDown: 'Перемістити вниз',
        addLocation: 'Додати нове місце розташування',
        editLocation: 'Редагувати місце розташування',
        companiesDatabase: 'База даних компаній',
        flows: 'Потоки',
        read: 'Читати',
        write: 'Писати',
        noImage: 'Немає зображення',
        email: 'E-mail',
        function: 'Функція',
        active: 'Активний',
        notActive: 'Неактивний',
        disabled: 'Відключено',
        entryNumber: 'Номер запису',
        issuedDate: 'Дата видачі',
        expiresDate: 'Дата закінчення терміну дії',
        move: 'Пересунути',
        separateForm: 'Відокремити від',
        separate: 'Відокремити',
        warehouse: 'Склад',
        actions: 'Дії',
        putInCurrentLocation: 'Розмістити у поточному місці',
        selectLocationFormRightMenu:
            'Вибрати місце розташування з правого меню',
        showUnassignedItems: 'Показати непризначені елементи',
        separated: 'Відокремлено',
        moved: 'Пересунуто',
        categories: 'Категорії',
        welcome: 'Ласкаво просимо',
        loginToSignaloCMMS: 'Увійти в Signalo CMMS',
        login: 'Увійти',
        loginByEmailAndPassword:
            'Увійти за допомогою електронної пошти та паролю',
        loginByCode: 'Увійти за допомогою коду',
        accessCode: 'Код доступу',
        enterEmail: 'Введіть електронну пошту',
        enterPassword: 'Введіть пароль',
        enterCode: 'Введіть код',
        userNotFound: 'Користувача не знайдено',
        userNotActivated: 'Користувач не активовано',
        userDisabled: 'Користувач відключено',
        wrongPassword: 'Неправильний пароль',
        locations: 'Розташування',
        pageNotFound: 'Сторінку не знайдено',
        group: 'Група',
        yes: 'Так',
        no: 'Ні',
        hourlyCost: 'Погодинна вартість',
        price: 'Ціна',
        newEntry: 'Новий запис',
        predictedFinishTime: 'Очікуваний час завершення',
        ok: 'Ok',
        archive: 'Архів',
        costs: 'Вартість',
        companyManagement: 'Керування компанією',
        companyData: 'Дані компанії',
        supportedLanguages: 'Підтримувані мови',
        en: 'Англійська',
        pl: 'Польська',
        es: 'Іспанська',
        de: 'Німецька',
        defaultLanguage: 'Мова за замовчуванням',
        companyLogo: 'Логотип компанії',
        notificationsManagement: 'Керування сповіщеннями',
        category: 'Категорія',
        today: 'Сьогодні',
        month: 'Місяць',
        week: 'Тиждень',
        day: 'День',
        close: 'Закрити',
        show: 'Показати',
        rollBackFormalConfirmation: 'Підтвердження формального відкату',
        signUp: 'Реєстрація',
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Мітка повного імені',
        userNameSurname: "Повне ім'я",
        userSurnameName: 'Прізвище та ім’я',
        phone: 'Номер телефону',
        password: 'Пароль',
        password_confirmation: 'Підтвердження пароля',
        unassignedItems: 'Неприсвоєні елементи',
        currency: 'Валюта',
        general: 'Загальні',
        timezone: 'Часовий пояс',
        users: 'Користувачі',
        groups: 'Групи',
        productionLine: 'Лінія виробництва',
        part: 'Частина',
        fittingParts: 'Відповідні частини',
        workSchema: 'Робочий схема',
        workSchemas: 'Робочі схеми',
        holiday: 'Відпустка',
        changePassword: 'Змінити пароль',
        showRest: 'Показати все',
        pageNotPermitted: 'Сторінка не дозволена',
        waitingForActivation: 'Очікування активації',
        editGroup: 'Редагувати групу',
        addGroup: 'Додати групу',
        reportProblem: 'Повідомити про проблему',
        describeOccuredIssue: 'Опишіть сталу проблему',
        markAllAsRead: 'Позначити все як прочитане',
        unitType: 'Тип одиниці',
        unit: 'Одиниця',
        unitPrice: 'Ціна за одиницю',
        notConfigured: 'Не налаштовано',
        rowsPerPage: 'Рядків на сторінці',
        rowsOfPage: 'із',
        true: 'Так',
        false: 'Ні',
        export: 'Експорт',
        chooseFileFormat: 'Виберіть формат файлу',
        exported: 'Експортовано',
        terminals: 'Термінали',
        terminal: 'Термінал',
        selectEquipment: 'Виберіть обладнання',
        futureIssues: 'Майбутні проблеми',
        scheduledOn: 'Заплановано на',
        planned: 'Заплановано',
        notPlanned: 'Не заплановано',
        showOpenIssues: 'Показати відкриті проблеми',
        pin: 'PIN',
        assignedEquipment: 'Присвоєне обладнання',
        terminalEquipment: 'Обладнання терміналу',
        detach: "Від'єднати",
        attach: 'Приєднати',
        dashboardConfig: 'Конфігурація панелі',
        addColumn: 'Додати стовпець',
        addRow: 'Додати рядок',
        removeRow: 'Видалити рядок',
        registerTerminal: 'Зареєструвати термінал',
        issueGeneratesCost: 'Збій працює за вартістю',
        selectColor: 'Виберіть колір',
        belowMinimum: 'Нижче мінімуму',
        belowOptimum: 'Нижче оптимуму',
        synchronization: 'Синхронізація',
        synchronizationExport: 'Експорт запасних частин',
        synchronizationImport: 'Імпорт запасних частин',
        mapping: 'Відображення',
        returnTo: 'Повернутися до',
        jobStatusses: 'Процеси',
        hidden: 'Приховано',
        editEvent: 'Редагувати подію',
        threeDays: '3 дні',
        addEvent: 'Додати подію',
        plannedIssues: 'Заплановані проблеми',
        currentService: 'Поточна послуга',
        searchLocation: 'Знайти місцезнаходження',
        all: 'Всі',
        unfinished: 'Незавершено',
        numberOfIssues: 'Кількість проблем',
        unknown: 'Невідомо',
        partEntry: 'Частина (вхід)',
        foundItems: 'Знайдені елементи',
        output: 'Вихід',
        copied: 'Скопійовано',
        link: 'Посилання',
        authorizationRequired: 'Необхідна авторизація',
        authorizationRequiredDescriptionUser:
            'На жаль, у вас недостатньо повноважень {value}. Зверніться до особи, яка має право на затвердження дії.',
        authorizationRequiredDescriptionTerminal:
            'Використовуйте свій код доступу, щоб авторизувати дію.',
        showAll: 'Показати все',
        showClassicView: 'Показати класичний вигляд',
        noIssuesInCategory: 'Немає проблем в цій категорії.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Кількість проблем в цій категорії та підкатегоріях.',
        numberOfIssuesInThisCategory: 'Кількість проблем в цій категорії.',
        minBarcodeLength: 'Мінімальна довжина штрих-коду',
        currentPage: 'Поточна сторінка',
        allPages: 'Усі сторінки',
        selectFormat: 'Виберіть формат',
        provided_currency: 'Надана валюта',
        provided_quantity: 'Надана кількість',
        provided_unit: 'Надана одиниця',
        provided_unit_price: 'Надана ціна за одиницю',
        unit_price: 'Ціна за одиницю',
        quantity_available: 'Доступна кількість',
        editBarcode: 'Редагувати штрих-код',
        crews: 'Команди',
        scheduleEventTypes: 'Типи розкладу подій',
        crew: 'Команда',
        scheduleEvent: 'Розклад подій',
        available: 'Доступно',
        'App\\Models\\Crew': 'Команда',
        'App\\Models\\User': 'Користувач',
        'App\\Models\\Equipment': 'Обладнання',
        'App\\Models\\Part': 'частина',
        Crew: 'Команда',
        User: 'Користувач',
        Equipment: 'Обладнання',
        Part: 'частина',
        scheduleEvents: 'Розклад подій',
        event: 'Подія',
        externalSystems: 'Зовнішні системи',
        user: 'Користувач',
        availability: 'Доступність',
        inheritColorFromParentIfCustomNotSet:
            'Наслідувати колір від батьківського елементу, якщо користувацький не встановлено',
        pickFromAllParts: 'Вибрати з усіх частин',
        takeTool: 'Взяти інструмент',
        returnTool: 'Повернути інструмент',
        personWhoTake: 'Особа, яка взяла',
        personWhoReturn: 'Особа, яка повернула',
        takenAt: 'Взято в',
        takenBy: 'Взято',
        toolIssuedBy: 'Інструмент видано',
        commentTake: 'Коментар при взятті',
        commentReturn: 'Коментар при поверненні',
        change: 'Змінити',
        onlyWithActiveRMIssues: 'Тільки з активними запитами RM',
        externalSystem: 'Зовнішня система',
        rejectIssue: 'Відхилити проблему',
        withdrawIssueRejection: 'Скасувати відхилення проблеми',
        rejectionReason: 'Причина відхилення',
        rejected: 'Відхилено',
        showCrewMembers: 'Показати членів команди',
        crewMembers: 'Члени команди',
        helpGroup: 'Служба',
        partsTakenByUser: 'Частини, взяті користувачем',
        pickParts: 'Видати частини',
        selectPersonWhoTakes: 'Вибрати особу, яка взяла',
        changePersonWhoTakes: 'Змінити особу, яка взяла',
        quantityToPick: 'Кількість для видачі',
        pickLocation: 'Місце видачі',
        selectPartsToPick: 'Вибрати частини для видачі',
        partSelected: 'Вибрана частина',
        scanCodeOr: 'Сканувати код або',
        returnPart: 'Повернути частину',
        myTakenParts: 'Частини, які я взяв',
        takenFromLocation: 'Взято з місця',
        takenQuantity: 'Взята кількість',
        providedUnit: 'Наданий одиниці',
        providedQuantity: 'Надана кількість',
        selectFromStorage: 'Вибрати з зберігання',
        selectFromMyPickedParts: 'Вибрати з моїх виданих частин',
        exportProcessInProgressMessage:
            'Процес експорту даних тільки що почався, коли він завершиться, ви побачите відповідне повідомлення, яке містить посилання на файл.',
        yourDocumentIsReady: 'Ваш документ готовий',
        rotateScreen: 'Повернути екран',
        addRule: 'Додати правило',
        editRule: 'Редагувати правило',
        summary: 'Резюме',
        onlyAvailableEmployees: 'Показати тільки доступних співробітників',
        calculated_unit_price: 'Перерахована ціна за одиницю',
        calculated_quantity: 'Кількість перетворено',
        next: 'наступний',
        maintenanceMode: 'Режим технічного обслуговування',
        applicationMayBeUnavailableForFewMinutes:
            'Додаток може бути недоступним протягом декількох хвилин',
        appWillRefreshIn: 'Додаток перезавантажиться в',
        landscape: 'альбом',
        portrait: 'портрет',
        orientation: 'орієнтація',
        format: 'формат',
        service: 'слуги',
        leader: 'майстри',
        defaultView: 'вигляд за замовчуванням',
        view: 'вид',
        oneDay: 'один день',
        object: "об'єкт",
        finished: 'закінчено',
        onlyNotFinished: 'Тільки не закінчено',
        generate: 'генерувати',
        error: 'помилка',
        cell: 'клітинка',
        resolutionSummary: 'Кінцевий підсумок',
        rejected_at: 'дата відмови',
        rejected_by: 'Відхилено',
        finishedByUser: 'Виконав',
        formalConfirmByUser: 'Офіційне підтвердження',
        formalConfirmAt: 'Дата офіційного підтвердження',
        valueDeleted: '[Значення видален]',
        hasNotPlannedIssue: 'Не має запланованих випусків',
        showInStorage: 'Показати в сховищі',
        changeCode: 'Змініть код',
        staffProfiles: 'Профілі співробітників',
        profile: 'Профіль',
        user_bug: 'помилка програми',
        user_kaizen: 'Пропозиція зміни',
        changeSuggestions: 'Змінити пропозиції',
        showOnlyCurrentlyAvailable: 'показати лише доступні на даний момент',
        resetPassword: 'Нагадати пароль',
        forgotPassword: 'Забули пароль',
        resetPasswordMailSent:
            'Ми надіслали посилання для встановлення нового пароля на вказану адресу електронної пошти',
        manyEventsThisTime: 'Багато подій у цей час',
        importScheduleCheckboxLabel:
            'Видалити заплановані події на вибраний місяць для співробітників, зазначених у файлі',
        inheritedEvent: 'Успадкована подія',
        inheritedModifiedEvent: 'Змінена успадкована подія',
        equipmentId: 'ID обладнання',
        entryId: 'ID запису',
        partId: 'ID частини',
        suggestionsEmail:
            'Електронна адреса, на яку надсилатимуться пропозиції змін',
        meters: 'лічильники',
        scanCardToAuth: 'Сканувати картку для авторизації',
        scanCard: 'Сканувати картку',
        cart: 'Ящик для обміну',
        emptyCardMessage:
            'Почніть сканувати продукти або виберіть їх зі списку, щоб додати їх у кошик.',
        terminalMode: 'Режим терміналу',
        askPermittedUserToConfirmPartsExchange:
            'Запитати дозволеного користувача для підтвердження обміну частинами',
        partsIssued: 'Частини видано',
        areYouSureAboutCancel: 'Ви впевнені, що хочете скасувати?',
        areYouSureAboutRemoveFromCart:
            'Ви впевнені, що хочете видалити з кошика?',
        standard: 'стандарт',
        idNumber: 'ID номер',
        takeParts: 'Взяти частини',
        returnParts: 'Повернути частини',
        quantityToReturn: 'Кількість для повернення',
        partsPendingApproval: 'Частини, що очікують схвалення',
        partsReturned: 'Частини повернуто',
        partsAddedToPendingApproval: 'Частини додано до очікування схвалення',
        approvePartsReturn: 'Схвалити повернення частин',
        partReturnApproved: 'Повернення частин схвалено',
        partUsage: 'Використання частин',
        awaitsReturn: 'Очікує повернення',
        entrySelection: 'Вибір запису',
        correctQuantity: 'Виправити кількість',
        quantityCorrection: 'Коригування кількості',
        entrySelectionAsc: 'Вибір запису (за зростанням)',
        entrySelectionDesc: 'Вибір запису (за спаданням)',
        metersSettings: 'Налаштування лічильників',
        countableFields: 'Поля для лічильників',
        equipmentTypes: 'Типи обладнання',
        fieldName: 'Назва поля',
        countableField: 'Поле для лічильника',
        partsStatusTaken: 'Взято',
        rejectPartsReturn: 'Відхилити повернення частин',
        areYouSureAboutRejectPartsReturn:
            'Ви впевнені, що хочете відхилити повернення частин?',
        partReturnRejected: 'Повернення частин відхилено',
        counterFields: 'Поля лічильників',
        counterName: 'Назва лічильника',
        counterFieldName: 'Назва поля лічильника',
        counterId: 'ID лічильника',
        counterUUID: 'UUID лічильника',
        counterPickerPlaceholder: 'Виберіть лічильник',
        pickFromPartsList: 'Вибрати зі списку частин',
        changeLocation: 'Змінити місцезнаходження',
        isPartStorageRoot: 'Частини зберігаються в корені',
        isStorageRoot: 'Частини зберігаються в корені',
        areYouSureAboutArchiveIssue:
            'Ви впевнені, що хочете архівувати це видання?',
        ganttChart: 'Діаграма Ганта',
        table: 'Таблиця',
        fittingEquipment: 'Обладнання для встановлення',
        notAssigned: 'Не призначено',
        counters: 'Лічильники',
        machineHourlyCostNotProvided: 'Погодинна вартість машини не вказана',
        eventTypesMightBeDefinedHere: 'Тут можна визначити типи подій',
        toolsTakenByUser: 'Інструменти, взяті користувачем',
        predictedReturnDate: 'Прогнозована дата повернення',
        estimatedTimeOfUsingToolInHours:
            'Орієнтовний час використання інструменту в годинах',
        showOnlyAvailable: 'Показувати тільки доступні',
        toolTakeLog: 'Журнал взяття інструментів',
        takeDate: 'Дата взяття',
        returnDate: 'Дата повернення',
        personWhoAcceptReturn: 'Особа, яка прийняла повернення',
        statisticStrategy: 'Стратегія доступності',
        EquipmentPlannedStrategy: 'Відповідно до плану роботи',
        EquipmentConstantAvailabilityStrategy: 'Завжди в наявності',
        actionAfterIssueFinish: 'Дія після завершення видання',
        enabled: 'Włączone',
        categoryOfNewIssue: 'Категорія нового видання',
        workNotStarted: 'Робота не розпочата',
        colorInherited: 'Колір успадкований',
        abcClassification: 'ABC класифікація',
        xyzClassification: 'XYZ класифікація',
        classification: 'Класифікація',
        filters: 'Фільтри',
        wipeFilters: 'Очистити фільтри',
        takePartsFromUser: 'Взяти частини у користувача',
        selectPersonWhoReturns: 'Виберіть особу, яка повертає частини',
        changePersonWhoReturns: 'Змінити особу, яка повертає частини',
        returnLocation: 'Місце повернення',
        returnQuantity: 'Кількість для повернення',
        globalSettings: 'Глобальні налаштування',
        delimiter: 'Роздільник',
        fieldRules: 'Правила поля',
        fieldValue: 'Значення поля',
        user_email_regex: 'Регулярний вираз для e-mail',
        barcodeLength: 'Довжина штрих-коду',
        partLine: 'Лінія частини',
        partFamily: 'Сімейство частини',
        partBatch: 'Партия частини (batch)',
        testValueValid: 'Тестове значення дійсне',
        testValueNotValid: 'Тестове значення недійсне',
        canBePicked: 'Можна вибрати',
        issue_criticality: 'Питання - критичність',
        issue_help_webapp: 'Проблеми - потрібна підтримка (додаток)',
        issue_help_terminal: 'Проблеми - потрібна підтримка (Термінал)',
        issue_kind: 'Тип звіту',
        HIDE: 'приховати',
        SHOW: 'Показати',
        REQUIRE: 'вимагати',
        propagateValues: 'Поширення цінності',
        archived: 'заархівований',
        singleEvent: 'Одноразовий вхід',
        seriesOfEvents: 'Серія записів',
        omitWeekends: 'Уникайте вихідних',
        allEntriesSaved: 'Усі записи додано',
        parentCategory: 'Батьківська категорія',
        first_day_of_week: 'Перший день тижня',
        assignEmployee: 'Призначити працівника',
        addNewMachine: 'Додайте нову машину',
        addNewTool: 'Додайте новий інструмент',
        parentLocation: 'Батьківське розташування',
        equipmentStates: 'стан обладнання',
        equipmentState: 'Стан обладнання',
        fontColor: 'колір шрифту',
        downtime: 'Час простою',
        setState: 'Встановити стан',
        from: 'від',
        to: 'до',
        inProgress: 'в процесі',
        noEntries: 'немає записів',
        products: 'продуктів',
        product: 'продукт',
        setCurrentProduct: 'Установіть продукт, який зараз виробляється',
        commentable: 'Можливість коментувати',
        allows_state_update: 'Необхідно змінити стан під час коментаря',
        undescribed: 'неможливо описати',
        state: 'Хвороба',
        productionMonitor: 'Монітор виробництва',
        undescribedStates: 'Неописані стани',
        toolsPicker: 'Взяти / повернути інструменти',
        toolsGroups: 'Групи інструментів',
        of: 'з',
        image: 'Фото',
        selectTools: 'Виберіть інструменти',
        takeTools: 'Інструменти завантаження',
        returnTools: 'Поверніть інструменти',
        askPermittedUserToConfirmToolsExchange:
            'Попросіть уповноважену особу підтвердити видачу/повернення інструментів шляхом сканування картки або введення коду.',
        toolsPendingApproval: 'Повернені інструменти очікують на затвердження',
        production_monitor_visible_columns:
            'Монітор виробництва - видимі колони',
        details: 'Подробиці',
        otherData: 'Інші дані',
        showAllTools: 'Показати всі інструменти',
        allTools: 'Всі інструменти',
        approveToolReturn: 'Прийняти повернення інструменту',
        rejectToolReturn: 'Відмовити у поверненні інструменту',
        areYouSureAboutRejectToolReturn:
            'Ви впевнені, що бажаєте відмовитися від повернення інструменту?',
        areYouSureAboutAcceptToolReturn:
            'Ви впевнені, що хочете підтвердити повернення інструменту?',
        toolReturnApproved: 'Повернення інструменту дозволено',
        toolReturnRejected: 'Повернення інструменту відхилено',
        toReturn: 'Повертати',
        toolsCart: 'Обмінна коробка - інструменти',
        toolsIssued: 'Інструменти завантажено',
        toolsAddedToPendingApproval:
            'Інструменти додано до списку очікування затвердження повернення',
        toolsReturned: 'Інструменти повернуто',
        mainShift: 'Основна зміна',
        scanCode: 'Відскануйте код',
        codeRecognized: 'Код розпізнано',
        moveAllEntriesFromCurrentLocation:
            'Перемістити всі записи з цього місця',
        newAwaitingValue: 'Нове значення очікує на затвердження',
        newValuesArePendingConfirmation: 'Зміни очікують на затвердження',
        changeRequests: 'Запити на зміни',
        currentValues: 'Поточні значення',
        requestedValues: 'Цінності, які потрібно змінити',
        removeRequestIsWaitingForApprove: 'Видалення очікує на схвалення',
        imageRemoveRequestLabel: 'Видалення фотографії',
        areYouSureAboutCancelChangeRequest:
            'Ви впевнені, що бажаєте скасувати запит на зміну?',
        document: 'документ',
        rename: 'Перейменувати',
        openInEditor: 'Відкрити в редакторі',
        unsavedChangesMayBeLost: 'Незбережені зміни можуть бути втрачені',
        location_name_regex: 'Правило назви місця розташування',
        employeesWorkingCount:
            'Кількість працівників, які працюють над цим питанням',
        always: 'завжди',
        indexes: 'Індекси',
        indexesEntriesTypes: 'Типи записів',
        indexEntry: 'Запис індексу',
        index: 'Індекс',
        pickIndex: 'Виберіть індекс',
        report: 'звіт',
        reportGenerationInProgress: 'Звіт генерується',
        production_monitor_equipment_state_change:
            'Зміна стану машини з монітора виробництв',
        part_entries_auto_barcode_generation:
            'Автоматична генерація штрих-коду для записів деталей',
        new_issue_equipment_kind: 'Тип обладнання в новому додатку',
        manageVisibleColumns: 'Налаштувати видимість стовпця',
        columnName: 'Назва стовпця',
        visible: 'Видно',
        partStorageRootWarningMessage:
            'Це розташування буде встановлено як місцезнаходження основного складу запчастин, склад і вікно вибору розташування складу дозволять вам вибирати лише записи, розташовані в цьому місці',
        entriesLocation: 'розташування записів',
        cloneIssue: 'Клон',
        machinesMap: 'Машинна карта',
        doYouWantToAddNewMarker: 'Бажаєте додати сюди новий тег?',
        areYouSureAboutRemoveMarker: 'Ви впевнені, що хочете видалити цей тег?',
        plants: 'Фабричні заводи',
        plant: 'Фабрика',
        buildings: 'Будівлі',
        building: 'будівля',
        floors: 'Підлоги',
        floor: 'Поверх',
        map: 'Карта',
        areYouSureAboutMoveMarker:
            'Ви впевнені, що бажаєте перемістити цей маркер?',
        marker: 'Маркер',
        addNewMarkerTooltipMessage:
            'Щоб додати новий маркер, клацніть правою кнопкою миші на карті.',
        takenTools: 'Випущені інструменти',
        askPermittedUserToConfirmToolExchange:
            'Попросіть уповноважену особу підтвердити видачу/повернення засобу шляхом сканування картки або введення коду.',
        warnDays: 'Сповіщення до закінчення терміну дії (днів)',
        licenseType: 'Тип ліцензії',
        licenseGroup: 'Ліцензійна група',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Вимагати підтвердження / відмову після повернення завантажених інструментів',
        attachments: 'Додатки',
        attachment: 'вкладення',
        searchInCurrentLocation: 'Пошук у вашому поточному місці',
        icon: 'значок',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'інший',
        tags: 'картки / Теги',
        tag: 'картку / Тег',
        userPinCode: 'PIN-код користувача картки',
        pin_code_field_type: 'Тип пін-коду',
        alphanumeric: 'буквено-цифровий',
        numeric: 'Числовий',
        showCodeOwnerNameDuringParing:
            'Показувати ім’я власника коду під час сполучення з карткою/тегом',
        showUsernameInCart: "Показати ім'я користувача в кошику",
        flag: 'Прапор',
        flags: 'Прапори',
        manageFlags: 'Керувати прапорами',
        skills: 'Навички',
        skill: 'Майстерність',
        skillRank: 'Рейтинг',
        selectToolsByType: 'Виберіть інструменти за типом',
        openToolsPickerOnCartInit:
            'Автоматично відкривати вікно вибору інструменту, коли ви переходите до кошика.',
        toolsTypes: 'Типи інструментів',
        workOrderTemplates: 'Шаблони нарядів',
        workOrderTemplate: 'Шаблон наряду',
        workOrders: 'Робочі наряди',
        workOrder: 'Наряд на роботу',
        employee: 'Співробітник',
        workOrderCreatedBy: 'На замовлення',
        print: 'Роздрукувати',
        issueCreated: 'Квиток створено',
        newIssue: 'Новий звіт',
        sampleButtonPlaceholder: 'Зразок кнопки',
        preferences: 'Уподобання',
        buttonsSize: 'Розмір кнопки',
        defaultValue: 'Значення за замовчуванням',
        warning: 'УВАГА',
        allowedIssuesCategories: 'Дозволені категорії проблем',
        hideAbilityToAssignEmployeesToIssue:
            'Приховати можливість призначати співробітників для вирішення проблеми',
        issuesWithRelatedCategories: 'Додайте підкатегорії',
        issuesLimit: 'Ліміт випусків',
        issuesLimits: 'Проблеми - межі',
        closeLocker: 'Закрийте шафу',
        closeLockerMessage: 'Щоб продовжити, закрийте шафу',
        closedTooFast: 'Ви закрили занадто швидко?',
        doYouWantToReopenLocker: 'Ви хочете знову відкрити шафку?',
        reopen: 'Знову відкрити',
        quit: 'Закінчити',
        hiddenFields: 'Приховані поля',
        defaultValues: 'Значення за замовчуванням',
        paddingBottom: 'Порожнє місце внизу',
        allVisibleFieldsRequired: 'Вимагати заповнення всіх видимих ​​полів',
        emailConfirmation: 'Підтвердження електронної адреси',
        user_active_after_email_confirm:
            'Обліковий запис користувача автоматично активується після підтвердження адреси електронної пошти',
        phone_change_requires_confirmation_code:
            'Зміна номера телефону вимагає підтвердження за допомогою коду',
        toolsLocation: 'Розташування інструменту',
        manageFilters: 'Керуйте фільтрами',
        erase: 'стерти',
        can_pick_undescribed_equipment_state:
            'Можливість вибору невимовного стану',
        helpdesk: 'Довідкова',
        measureTypes: 'Види вимірювань',
        measureType: 'Тип вимірювання',
        measurable: 'Вимірний показник',
        measurables: 'Вимірні показники',
        measurements: 'Вимірювання',
        measurement: 'Вимірювання',
        measuredAt: 'Дата вимірювання',
        employeeNumber: 'номер працівника',
        lastLocation: 'Останнє місце розташування',
        readonly: 'Лише для читання',
        equipment: 'Обладнання',
        conditions: 'Умови',
        permission: 'Дозвіл',
        formula: 'Формула',
        notification: 'Сповіщення',
        transition: 'Перехід',
        fillValuesToChangeState: 'Заповніть значення, щоб змінити статус.',
        loginTo: 'Увійти в',
        appName: 'Signalo CMMS',
        manageState: 'Керувати станом',
        webMessage: 'Веб-повідомлення',
        terminalId: 'Ідентифікатор терміналу',
        operatorId: 'ID оператора',
        newConversation: 'Нова тема',
        application: 'додаток',
        phones: 'Номери телефонів',
        message: 'повідомлення',
        channels: 'Канали',
        url: 'URL`si',
        kind: 'Добрий',
        forkfleetConfigId: 'Конфігурація Forkfleet',
        create: 'створити',
        terminate: 'припинити',
        recreateIssue: 'Повторно створіть квиток',
        ordinal: 'Порядкове значення',
        parameterName: 'Назва параметра',
        backgroundColor: 'Колір фону',
        columns: 'Кількість стовпців',
        colspan: 'Ширина (стовпці)',
        fill: 'Повний',
        loginAsThisUser: 'Увійдіть як цей користувач',
        partLot: 'Серія',
        minBrowserVersion: 'Потрібна мінімальна версія браузера',
        currentVersion: 'Поточна версія',
        equipment_planned_completed_percent_target:
            'Відсоток виконання планових перевірок',
        autoTranslate: 'Автоматичний переклад',
        auto_translation: 'Автоматичний переклад',
        awaitingAutoTranslation: 'Очікування автоматичного перекладу',
        signaturePinTagConfirmationText1: 'Підпишіться @:common.PIN_CODE_LABEL',
        signaturePinTagConfirmationText2: 'або відскануйте картку.',
        signedWithPinCode: 'Підписано @:common.PIN_CODE_LABEL',
        signedWithTAG: 'Підписано карткою/біркою',
        trusted_device_code_login_users_limit:
            'Швидкий вхід - кількість відображених користувачів',
        display_fields_issue_created_at: 'Показувати поля - Створення звіту',
        docs_sidebar_hidden_by_default:
            'Документи - сховати бокову панель за замовчуванням',
        issue: 'Повідомлення',
        control: 'Контроль',
        compatibility: 'Сумісність',
        replacement: 'Заміна',
        backCompatibility: 'Двостороння сумісність',
    },
    placeholders: {
        part: 'Виберіть частину...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Номер телефону...',
        password: 'Пароль...',
        password_confirmation: 'Підтвердження пароля...',
        email: 'E-mail...',
    },
    auth: {
        notYourAccountQuestion: 'Це не ваш аккаунт?',
    },
    signup: {
        registered: 'Успішно!',
        emailConfirmed: 'Електронну адресу підтверджено.',
        registered_info:
            'Запитайте у свого керівника про активацію вашого акаунту',
        confirmEmailAddress:
            'Ваш обліковий запис створено, натисніть посилання в електронному листі, щоб підтвердити свою адресу.',
        tokenNotFoundError:
            'Електронну адресу вже підтверджено або посилання для підтвердження недійсне.',
    },
    paramTypes: {
        text: 'Текст',
        note: 'Нотатка',
        integer: 'Ціле число',
        decimal: 'Десяткове число',
        date: 'Дата',
        time: 'Година',
        datetime: 'Дата та година',
        color: 'Колір',
        icon: 'Іконка',
        boolean: 'Так / Ні',
        signature: 'підпис',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Назва',
        path: 'Шлях до файлу',
        category: 'Категорія',
        equipment: 'Обладнання',
        criticality: 'Критичність',
        status: 'Статус',
        created: 'Створено',
        createdBy: 'Створено',
        fp: 'FP',
        type: 'Тип',
        designation: 'Ознака',
        symbol: 'Символ',
        serialNumber: 'Серійний номер',
        registryNumber: 'Реєстраційний номер',
        udtNumber: 'UDT номер',
        manufacturedYear: 'Рік виготовлення',
        actions: 'Дії',
        title: 'Заголовок',
        data: 'Дата',
        archived: 'Архівовано',
        manufacturerSymbol: 'Символ виробника',
        min: 'Min',
        opt: 'Opt',
        quantity: 'Кількість',
        priority: 'Пріоритет',
        price: 'Ціна',
        kind: 'Тип',
        description: 'Опис',
        default: 'За замовчуванням',
        warning: 'Попередження',
        problem: 'Проблема',
        fixing: 'Виправлення',
        changeOrder: 'Зміна порядку',
        required: 'Необхідно',
        icon: 'Іконка',
        color: 'Колір',
        subCategories: 'Підкатегорії',
        barCode: 'Штрих-код',
        subLocations: 'Підрозділи',
        categories: 'Категорії',
        image: 'Зображення',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'Email',
        phone: 'Номер телефону',
        function: 'Функція',
        department: 'Департамент',
        accountStatus: 'Статус облікового запису',
        shift: 'Зміна',
        licenseNumber: 'Номер ліцензії',
        issuedDate: 'Дата видачі',
        expiresDate: 'Дата закінчення дії',
        entries: 'Записи',
        entryNumber: 'Номер запису',
        buyPrice: 'Вартість покупки',
        currentLocationQuantity: 'Кількість в поточному розташуванні',
        group: 'Група',
        string: 'Текст',
        integer: 'Ціле число',
        toolsGroup: 'Група інструментів',
        manufacturer: 'Виробник',
        shortName: "Коротке ім'я",
        locationName: 'Назва розташування',
        subLocationsQuantity: 'Кількість у підрозділах',
        isWorkingOnIssue: 'Робота над проблемою',
        openIssues: 'Відкриті проблеми',
        notificationDate: 'Дата повідомлення',
        titleAndDescription: 'Заголовок та опис',
        read: 'Прочитано',
        created_at: 'Створено',
        received_at: 'Отримано',
        started_at: 'Розпочато',
        arrived_at: 'Прибуло',
        finished_at: 'Завершено',
        country: 'Країна',
        city: 'Місто',
        progress: 'Прогрес',
    },
    searchConfig: {
        id: 'ID',
        name: 'Назва...',
        shortName: 'Коротка назва...',
        country: 'Країна...',
        email: 'Email...',
        group: 'Група...',
        planned: 'Заплановано',
        category: 'Категорія...',
        object: 'Об’єкт...',
        criticality: 'Критичність',
        fp: 'FP',
        type: 'Тип...',
        designation: 'Ознака...',
        symbol: 'Символ...',
        serialNumber: 'Серійний номер...',
        registryNumber: 'Реєстраційний номер...',
        udtNumber: 'UDT номер...',
        manufacturedYear: 'Рік виробництва...',
        manufacturerSymbol: 'Символ виробника...',
        priority: 'Пріоритет...',
        quantity: 'Кількість...',
        buyPrice: 'Ціна купівлі...',
        kind: 'Вид...',
        toolsGroup: 'Група інструментів...',
        function: 'Функція...',
        department: 'Відділ...',
        status: 'Статус...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Телефон...',
        barCode: 'Штрих-код',
        color: 'Колір...',
        icon: 'Іконка...',
        machine: 'Машина...',
        tool: 'Інструмент...',
        urgentAndOutdated: 'Терміново та застаріло',
        urgent: 'Терміново',
        expired: 'Застаріло',
        manufacturer: 'Виробник',
    },
    errors: {
        error: 'Виникла помилка',
        wrongEmail: 'Недійсний email',
        wrongPasswordLength: 'Довжина пароля повинна бути не менше 8 символів.',
        wrongCodeLength: 'Довжина коду повинна бути не менше 5 символів.',
        passwordsNotMatch: 'Паролі не збігаються',
        codesNotMatch: 'Коди не збігаються',
        codeAlreadyInUse: 'Код вже використовується',
        expiresDateLowerThanIssued:
            'Дата закінчення не може бути менше, ніж дата видачі.',
        cannotMoveToTheSameLocation: 'Не можливо переміститися в ту ж локацію.',
        locationRequired: "Локація обов'язкова.",
        putQuantity: 'Введіть кількість для розділення.',
        valueGreaterThanQuantity: 'Значення перевищує загальну кількість.',
        wholeCannotBeDistinguished: 'Весь не може бути розділений.',
        yearMustBeGreaterThan: 'Рік повинен бути більше, ніж ',
        passwordConfirmationNotMatch: 'Паролі не збігаються',
        mustBeInteger: 'Значення повинно бути цілим числом',
        valueTooLong: 'Значення занадто довге',
        wrongPhoneNumber: 'Неправильний номер телефону',
        phoneNumberAlreadyTaken: 'Номер телефону вже використовується',
        emailAlreadyTaken: 'Email вже використовується',
        notFound: 'Не знайдено',
        sessionExpired: 'Сесія закінчилася',
        tenantNotFound:
            'Вказаної конфігурації не існує. Перевірте адресу сайту та спробуйте ще раз.',
        selectEquipmentTypeToConfigureParameters:
            'Виберіть тип обладнання для налаштування параметрів.',
        noParametersToConfigure:
            'Обраний тип обладнання не має параметрів для налаштування.',
        terminalAlreadyRegistered: 'Термінал вже зареєстровано.',
        invalidPin: 'Недійсний ПІН',
        eventCollision:
            'Час події, яку ви хочете додати, перетинається з часом іншої події.',
        mustStartWithSlash: 'Має починатися з /',
        mustBeBetween: 'Значення має бути між:',
        minLength: 'Мінімальна довжина: ',
        maxLength: 'Максимальна довжина: ',
        invalidInputForCodeType: 'Недійсний ввід для обраного типу коду',
        invalidCodeOrNoPermission:
            'Код недійсний або у вас недостатньо прав для виконання цієї дії.',
        endDateLowerThanStart:
            'Дата закінчення не може бути нижче дати початку',
        iconAlreadyTaken: 'Іконка вже використовується',
        notEnoughQuantityInStorage: 'Недостатньо кількості в складі.',
        valueTooLow: 'Значення занадто низьке',
        valueTooHigh: 'Значення занадто високе',
        maxAvailableQuantity: 'Максимальна кількість',
        someFilesRejectedDueToSize:
            'Деякі файли було відхилено через розмір. Максимальний розмір одного файлу:',
        cameraDeviceNotFound: 'пристрій камери не знайдено',
        cameraPermissionDenied:
            'Доступ до камери пристрою заблоковано в налаштуваннях сайту, скиньте налаштування сайту і дозвольте використовувати камеру.',
        passwordResetLinkExpired:
            'Термін дії посилання для зміни пароля закінчився',
        noInternetConnection: 'Немає підключення до Інтернету',
        minimum: 'Мінімум',
        mustBeGreaterThan: 'Має бути більше, ніж',
        noEventTypesDefined: 'Не визначено жодного типу події',
        regexPatternDelimiterError:
            'За допомогою символу \\ роздільник має бути пропущений, наприклад: \\/',
        emailNotMatchPatternDefiniedInTenant:
            'Email не відповідає шаблону, визначеному в орендарі',
        partMustHaveEntriesToCorrectQuantity:
            'Частина повинна мати записи для виправлення кількості.',
        fileTooBigToOpenWillBeDownloaded:
            'Файл завеликий для відкриття, файл буде завантажено на ваш пристрій.',
        entriesNotSavedDueToCollision:
            'Записи не додано. У вибраний час події вже існують.',
        someEntriesWereRejected:
            'Деякі записи не додано, оскільки вони конфліктують з іншими подіями.',
        toolAlreadyInCart: 'Цей інструмент вже у вашому кошику',
        toolAlreadyTaken: 'Цей інструмент уже випущено',
        toolIsNotTaken: 'Цей інструмент не було випущено',
        documentNotEditable: 'Цей документ не можна редагувати',
        notPermissionsToEditDocument:
            'Ви не маєте дозволу редагувати цей документ',
        cannotLoadDocumentNoPath:
            'Не вдалося завантажити документ - недійсна адреса',
        locationNameNotMatchPatternDefiniedInTenant:
            'Назва не відповідає правилу, визначеному в налаштуваннях',
        noFloorLayoutProvided: 'Поверх не має визначеної карти',
        maximum: 'Максимальне значення',
        allLanguagesRequired: 'Заповніть значення всіма мовами',
        noItemsAvailable: 'Немає доступних товарів',
        noFlagsConfigured: 'Прапори не визначено',
        noSkillsDefined: 'Навички не визначені',
        someoneIsWorkingOnIssue:
            'Не всі працівники завершили роботу над цим звітом. Ви впевнені, що хочете завершити це?',
        fillAllRequiredParameters: 'Заповніть усі необхідні параметри.',
        issueLimitError:
            'Ліміт питань у вибраній категорії для групи досягнуто: ',
        issueLimitError2: 'і функція: ',
        duplicateError: 'Це значення вже існує',
        versionErrorMessage:
            'Ваші останні зміни не було збережено, оскільки хтось інший вніс зміни в той же час. Оновіть сторінку та повторіть спробу.',
        firstLoginTrustedDeviceError:
            'Перший вхід на новому пристрої вимагає введення адреси електронної пошти та пароля.',
        tagNotFound: 'Картку/мітку не розпізнано',
        noChecklistsAssignedToControl:
            'Для вибраного елемента керування не призначено контрольний список',
        lockerNotConnected: 'Замок не підключено',
        lockerNotAvailable: 'Замок недоступний',
        noChecklistItemsError: 'Контрольний список не налаштовано',
    },
    navDrawer: {
        dashboard: 'Панель',
        issues: 'Проблеми',
        timetable: 'Розклад',
        machines: 'Машини',
        tools: 'Інструменти',
        parts: 'Частини',
        storage: 'Склад',
        staff: 'Персонал',
        configuration: 'Налаштування',
        notes: 'Нотатки',
        notifications: 'Сповіщення',
        profile: 'Профіль',
        supervision: 'Нагляд',
    },
    barcodeScanner: {
        barCode: 'Штрих-код',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Категорія...',
        selectCategory: 'Виберіть категорію',
        noSubcategories: 'Немає підкатегорій',
    },
    companies: {
        addCompany: 'Додати компанію',
        editCompany: 'Редагувати компанію',
        fullName: 'Повне найменування',
        shortName: 'Скорочене найменування',
        group: 'Група',
        country: 'Країна',
        city: 'Місто',
        street: 'Вулиця',
        postCode: 'Поштовий індекс',
        phone: 'Телефон',
        email: 'Електронна пошта',
        website: 'Веб-сайт',
        NIP: 'Налоговий номер (NIP)',
        REGON: 'Національний реєстр підприємств (REGON)',
        active: 'Активно',
        nameRequired: 'Потрібно вказати найменування',
        shortNameRequired: 'Потрібно вказати скорочене найменування',
    },
    issues: {
        tookAt: 'Прийнято о',
        changeHistory: 'Історія змін',
        load: 'Завантажити',
        date: 'Дата',
        createdBy: 'Створено',
        action: 'Дія',
        data: 'Дані',
        created: 'Створено',
        updated: 'Оновлено',
        deleted: 'Видалено',
        restored: 'Відновлено',
        issues: 'Проблеми',
        issue: 'Проблема',
        by: 'від',
        name: 'Назва',
        applicantsDescription: 'Опис заявника',
        accidentDescription: 'Опис події',
        jobDescription: 'Опис роботи',
        jobSummary: 'Підсумок роботи',
        category: 'Категорія',
        status: 'Статус',
        noFlow: '[Немає потоку]',
        equipment: 'Обладнання',
        criticality: 'Критичність',
        hour: 'Година',
        formalConfirmation: 'Формальне підтвердження',
        formalConfirmationShortcut: 'Потрібне Фп',
        formalConfirmationRequired: 'RO gereklidir',
        parameter: 'Параметр',
        value: 'Значення',
        addIssue: 'Додати проблему',
        expectedCompletionDate: 'Очікувана дата завершення',
        issueDescription: 'Опис проблеми',
        partsUsage: 'Використання деталей',
        assignedEmployees: 'Призначені співробітники',
        requiredHelp: 'Необхідна допомога',
        returnParts: 'Повернути деталь',
        confirmUnassignEmployeeWhoTakenIssue:
            'Цей співробітник взяв вибрану проблему. Ви хочете відмінити його призначення?',
        responsibleUser: 'Відповідальний користувач',
        responsibleRules: 'Правила відповідальності користувачів',
    },
    machines: {
        machines: 'Машини',
        xIssuesNotPlanned: ' (не заплановано)',
        noIssues: 'Немає проблем',
    },
    maintanance: {
        maintanance: 'Технічне обслуговування',
    },
    notes: {
        notes: 'Нотатки',
        note: 'Нотатка',
        title: 'Заголовок',
        archived: 'Заархівовано',
    },
    parts: {
        parts: 'Деталі',
        warehouseOutgoings: 'Видачі зі складу',
        fittingEquipmentTypes: 'Підходящі типи обладнання',
        goToEquipmentType: 'Перейти до типу обладнання',
        selectPart: 'Вибрати деталь',
        usageReason: 'Причина',
        usageOtherReason: 'Інше',
        replacements: 'Заміни',
        partEntry: 'Введення деталі',
        goToPart: 'Перейти до деталі',
        fittingMachines: 'Підбірні машини',
    },
    costCenter: {
        costCenter: 'Центр витрат',
    },
    equipmentTypes: {
        equipment: 'Обладнання',
        newEquipmentType: 'Новий тип обладнання',
        fittingParts: 'Підходящі деталі',
        goToParts: 'Перейти до деталей',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: 'Визначення машин та інструментів',
    },
    flows: {
        flow: 'Потік',
        states: 'Стани',
        transitions: 'Переходи',
        state: 'Стан',
        default: 'За замовчуванням',
        warning: 'Попередження',
        problem: 'Проблема',
        fixing: 'Виправлення',
        finished: 'Готово',
    },
    parameters: {
        categoryParameter: 'Параметр категорії',
        equipmentTypeParameter: 'Параметр типу обладнання',
    },
    staff: {
        staff: 'Персонал',
        editUserAccess: 'Редагувати доступ користувача',
        permissionsUpdated: 'Дозволи оновлено',
        passwordUpdated: 'Пароль оновлено',
        codeUpdated: 'Код оновлено',
        changePasswordAndCode: 'Змінити пароль та код',
        goToLicenses: 'Перейти до ліцензій',
        editAccess: 'Редагувати доступ',
        editUser: 'Редагувати користувача',
        addUser: 'Додати нового користувача',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: 'Статус акаунту',
        phoneNumber: 'Номер телефону',
        department: 'Відділ',
        passwordChange: 'Зміна пароля',
        codeChange: 'Зміна коду',
        newPassword: 'Новий пароль',
        confirmNewPassword: 'Підтвердити новий пароль',
        changePassword: 'Змінити пароль',
        newCode: 'Новий код',
        confirmNewCode: 'Підтвердити новий код',
        changeCode: 'Змінити код',
        addEntry: 'Додати запис',
        editEntry: 'Редагувати запис',
        editLicense: 'Редагувати ліцензію',
        addLicense: 'Додати ліцензію',
        licenseNumber: 'Номер ліцензії',
        prefferedLocale: 'Бажана локаль',
        oldPassword: 'Старий пароль',
        newPasswordConfirmation: 'Підтвердити новий пароль',
        reading: 'Відображення',
        creating: 'Створення',
        updating: 'Оновлення',
        deleting: 'Видалення',
        importScheduleFile: 'Імпорт розкладу з файлу',
        importSchedule: {
            errors: {
                user_not_found: 'Користувач не знайдений [{user}]',
                user_found_many: 'Знайдено {count} користувачів [{user}]',
                event_collision: 'зіткнення подій',
                hour_cell_parse: 'Помилка аналізу клітинки',
            },
        },
        oldCode: 'старий код',
        newCodeConfirmation: 'Підтвердження нового коду',
        setAccessBasedOnProfile: 'Надати доступ на основі профілю',
        selectAccessMergeType: 'Виберіть спосіб об’єднання дозволів',
        noAccessesInProfileMessage:
            'Вибраний профіль не має дозволів. Ви все одно хочете перезаписати?',
    },
    breadCrumb: {
        configuration: 'Конфігурація',
        locations: 'Місця',
        home: 'Домашня сторінка',
        machines: 'Машини',
        tools: 'Інструменти',
        issues: 'Проблеми',
        notes: 'Нотатки',
        maintenance: 'Обслуговування',
        parts: 'Частини',
        warehouse: 'Склад',
        dictionary: 'Словник',
        categories: 'Категорії',
        parameters: 'Параметри',
        costCenter: 'Центр витрат',
        flows: 'Потоки',
        states: 'Стани',
        transitions: 'Переходи',
        shiftSchemas: 'Графіки змін',
        shifts: 'Зміни',
        definitionsOfMachinesAndToolsTypes:
            'Визначення типів машин та інструментів',
        add: 'Додати',
        edit: 'Редагувати',
        staff: 'Персонал',
        licenses: 'Ліцензії',
        entries: 'Записи',
        companiesDatabase: 'База даних компаній',
        companyManagement: 'Керування компанією',
        companyData: 'Дані компанії',
        supportedLanguages: 'Підтримувані мови',
        en: 'Англійська',
        pl: 'Польська',
        es: 'Іспанська',
        de: 'Німецька',
        it: 'Італійська',
        fr: 'Французька',
        ru: 'Російська мова',
        uk: 'Українська',
        pt: 'Португальська',
        tr: 'турецька',
        nl: 'голландська',
        sr: 'сербська',
        defaultLanguage: 'Мова за замовчуванням',
        notifications: 'Сповіщення',
        notificationsManagement: 'Керування сповіщеннями',
        myProfile: 'Мій профіль',
    },
    attributeTypes: {
        text: 'Текст',
        note: 'Нотатка',
        integer: 'Ціле число',
        decimal: 'Десяткове число',
        date: 'Дата',
        time: 'Час',
        dateTime: 'Дата та час',
        color: 'Колір',
        icon: 'Іконка',
        boolean: 'Так/Ні',
    },
    costCalculator: {
        costCalculator: 'Калькулятор вартості',
        waitTime: 'Час очікування',
        serviceTime: 'Час сервісу',
        suspendTime: 'Час призупинення',
        totalTime: 'Загальний час',
        estimatedCost: 'Оцінена вартість',
        calculate: 'Обчислити',
        withoutParts: 'Без деталей',
        timeOfReportingIssue: 'Час повідомлення про проблему',
        timeOfServiceStart: 'Час початку сервісу',
        timeOfReportingEnd: 'Час закінчення сервісу',
        days: 'Дні',
        hours: 'Години',
        minutes: 'Хвилини',
        enterNewTime: 'Введіть новий час',
        fromIssueReportToServiceStart:
            'Час від повідомлення про проблему до початку сервісу',
        fromServiceStartToServiceEnd:
            'Час від початку сервісу до закінчення сервісу',
        workTime: 'Час роботи',
        includeAwaitingTime: 'Включити час очікування',
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'Мої проблеми',
                assignedToMe: 'Присвоєно мені',
                assignedToGroup: 'Присвоєно моєму групі',
                tookByMe: 'Взято мною',
                takeIssueBtn: 'Взяти',
                arriveIssueBtn: 'Я прибув',
                finishIssueBtn: 'Завершити',
                history: 'Історія',
                myResponsible: 'Я відповідаю за',
            },
        },
    },
    synchronization: {
        enabled: 'Увімкнено',
        hasHeaders: 'Має заголовки',
        leaveFile: 'Залишити файл',
        host: 'Хост',
        port: 'Порт',
        protocol: 'Протокол',
        username: "Ім'я користувача",
        password: 'Пароль',
        root: 'Кореневий каталог',
        encoding: 'Кодування',
        separator: 'Роздільник',
        externalSystemId: 'ID зовнішньої системи',
        cronExpression: 'Вираз Cron',
        appendFullStock: 'Додати повний запас',
        includeHeaders: 'Включити заголовки',
        withTrashed: 'З видаленими даними',
        filePattern: 'Шаблон файлу',
    },
    processes: {
        created_at: 'Створено в',
        started_at: 'Почато в',
        updated_at: 'Оновлено в',
        finished_at: 'Завершено в',
        attempts: 'Спроби',
        queue: 'Черга',
        job_id: 'ID завдання',
        job_uuid: 'UUID завдання',
        progress_max: 'Макс. прогрес',
        progress_now: 'Поточний прогрес',
        outputMessage: 'Вихідне повідомлення',
        status: {
            queued: 'у черзі',
            executing: 'виконується',
            finished: 'завершено',
            failed: 'не вдалося',
            retrying: 'повторна спроба',
            undefined: 'невизначений',
        },
    },
    weekDays: {
        mo: 'Понеділок',
        tu: 'Вівторок',
        we: 'Середа',
        th: 'Четвер',
        fr: "П'ятниця",
        sa: 'Субота',
        su: 'Неділя',
    },
    reports: {
        reports: 'Звіти',
        dateFrom: 'Дата початку',
        dateTo: 'Дата закінчення',
        types: {
            operation_sheet: 'Операційний аркуш',
            issue_summary: 'підсумок проблеми',
            grouped_summary: 'підсумковий звіт',
            storage_operations: 'Складські операції',
            part_quantity_export: 'Кількість запчастин',
        },
        reportFor: 'Звіт за',
        includeQuantityLeft0: 'Включіть частини з нульовою кількістю',
    },
    logs: {
        issues: {
            escalation: 'Ескалація ({minutes} хв) - надіслано повідомлення',
        },
        issueEmployee: {
            assignedAt: 'Працівник призначений:',
            receivedAt: 'Працівник отримав:',
            tookAt: 'Працівник взяв на себе',
            finishedAt: 'Працівник завершив',
            deletedAt: 'Працівник видалений з звернення',
        },
    },
    units: {
        no: 'шматок',
        st: 'встановити',
    },
    rrule: {
        frequency: 'частота',
        dtstart: 'Дата початку',
        tzid: 'Часовий пояс',
        until: 'доки',
        count: 'Рахувати',
        interval: 'інтервал',
        wkst: 'День початку',
        byweekday: 'По буднях',
        bymonth: 'По місяцях',
        yearly: 'щорічно',
        monthly: 'щомісяця',
        weekly: 'щотижня',
        daily: 'щодня',
        hourly: 'щогодини',
        minutely: 'щохвилини',
        secondly: 'По друге',
        infinitePeriodicityMessage:
            'Періодичність нескінченна, через продуктивність відображається лише 500 рядків',
    },
    months: {
        jan: 'січня',
        feb: 'лютий',
        mar: 'березень',
        apr: 'квітень',
        may: 'Може',
        jun: 'червень',
        jul: 'липень',
        aug: 'серпень',
        sep: 'Вересень',
        oct: 'жовтень',
        nov: 'Листопад',
        dec: 'Грудень',
    },
    charts: {
        charts: 'діаграми',
        count: 'Кількість питань',
        total: 'Загальний час випуску (від звіту до завершення)',
        serw: 'Загальний час ремонту (Ttotal - Twait)',
        mttr1: 'Середній час від звіту до завершення',
        mttr2: 'Середній час від знімка до завершення',
        mtbf: 'Середній час роботи між проблемами',
        mttf: 'Середній час до відмови',
    },
    accessMergeValues: {
        sum: 'сума',
        product: 'Продукт',
        overwrite: 'перезаписати',
    },
    tpm: {
        history: 'Історія',
        standardObstacle: 'Стандартна перешкода',
        customObstacle: 'Спеціальна перешкода',
        bhp: 'Безпека та гігієна праці',
        returnToMainPage: 'Повернутися до головної сторінки',
        bhpMessage:
            'Якщо ви помічаєте ризики для безпеки, негайно повідомте про це вашого безпосереднього керівника та скористайтеся формою повідомлення, що знаходиться під оголошувальною дошкою.',
        ok: 'ОК',
        send: 'Надіслати',
        description: 'Опис',
        title: 'Назва',
        realization: 'Реалізація',
        answer: 'Відповідь',
        pendingSurveys: 'Очікуючі опитування',
        surveys: 'Опитування',
        systemSurvey: 'Системне опитування',
        addPage: 'Додати сторінку',
        createSurvey: 'Створити опитування',
        addSection: 'Додати розділ',
        addQuestion: 'Додати питання',
        questionContent: 'Зміст питання',
        answerOption: 'Варіант відповіді',
        addQuestionAnswer: 'Додати варіант відповіді',
        surveyName: 'Назва опитування',
        sectionName: 'Назва розділу',
        noSurveyAnswers: 'Немає відповідей',
        removeSection: 'Видалити розділ',
        published: 'Опубліковано',
        unpublished: 'Неопубліковано',
        pendingPublication: 'Зміни очікують на публікацію',
        removeQuestion: 'Видалити питання',
        removeAnswer: 'Видалити варіант відповіді',
        publish: 'Опублікувати',
        unpublish: 'Зняти з публікації',
        previewResults: 'Переглянути результати',
        supervisior: 'Керівник',
        surveyResults: 'Результати опитування',
        surveysEvents: 'Конфігурація подій - опитування',
        operatedBy: 'Управляється',
        confirmReadInformations: 'Підтверджую, що прочитав інформацію',
        noticeContent: 'Вміст повідомлення',
        notice: 'Повідомлення',
        surveyEventName: 'Назва події',
        survey: 'Опитування',
        newIssue: 'Нове питання',
        surveyEventConfigurationAlreadyExists: 'Конфігурація події вже існує',
        lastComment: 'Останній коментар відповідальної особи',
        surveyNotConfigured: 'Опитування не налаштовано',
        fillSurvey: 'Заповнити опитування',
        singleSurveyEntries: 'одиничні результати',
        groupedSurveyEntries: 'Згруповані результати',
        publicationId: 'ID публікації',
        publicationDate: 'Дата публікації',
        versionId: 'ідентифікатор версії',
        answersCount: 'Кількість відповідей',
        answers: 'Відповіді',
        withoutSupervisor: 'Немає наглядача',
        defaultSupervisor: 'Наглядач за замовчуванням',
        flowStateFlags: 'Прапори стану',
        qrActionsSettings: 'Налаштування дій QR-коду',
        loginRequired: 'Потрібен вхід',
        questionContext: 'контекст питання',
        currentSurveyVersionPreview:
            'Попередній перегляд поточної версії опитування',
        surveyDescription: 'Опис опитування',
        sectionDescription: 'Опис розділу',
        instructions: 'Інструкції',
        instruction: 'інструкція',
        instructionRevisions: 'Ревізії',
        checklists: 'Контрольні списки',
        checklist: 'Контрольний список',
        checklistItem: 'Пункт списку',
        manageChecklistFields: 'Керуйте елементами списку',
        checklistItemDisplayOptions: 'Показані елементи',
        revisionAutoRejectedInfo: '[Система] Відхилено – створено нову версію',
    },
    checklists: {
        itemBasic: 'Базовий елемент',
        itemSeparator: 'Роздільник',
        itemSection: 'Розділ',
        publish: 'Опублікувати',
        previewCurrentVersion: 'Попередній перегляд поточної версії',
    },
};
